// lib
import { batch } from "react-redux";
// src
import back from "services/plannings";
import { fetchEnableds } from "actions/events/thunks";
import * as sync from "./index";

export const loginAndKeepPath = (pathname, history) => async (dispatch) => {
  dispatch(sync.setRedirect(pathname));
  history.push("/login");
};

export const fetchBackToken = (ticket) => async (dispatch, getState) => {
  await back.request(
    `/token/${ticket}`,
    dispatch,
    getState,
    () => dispatch(sync.backTokenRequest()),
    (json) => {
      batch(() => {
        const { identity, token, ...state } = json;
        dispatch(sync.backTokenSuccess({ identity, token }));
        dispatch(sync.userStateSuccess(state));
        dispatch(fetchEnableds());
      });
    },
    () => dispatch(sync.disconnect()),
  );
};

export const fetchUserState = () => async (dispatch, getState) => {
  await back.request(
    "/my/state",
    dispatch,
    getState,
    () => dispatch(sync.userStateRequest()),
    (json) => {
      batch(() => {
        dispatch(sync.userStateSuccess(json));
        dispatch(fetchEnableds());
      });
    },
    () => dispatch(sync.userStateFailure()),
  );
};
